import {
  getApi,
  getApiById,
  patchApi,
  putApiWithoutId,
} from "../../Shared/Services/RestService";
import {
  PaymentGatewayAdminResponse,
  PaymentGatewayConfigRequest,
} from "../Types/PaymentGatewayType";

const BASE = "/admin/payment-gateways";

/** Every gateway, admin view. Secrets are absent from the response by construction. */
export const getPaymentGateways = () => {
  return getApi<PaymentGatewayAdminResponse[]>(BASE);
};

export const getPaymentGatewayByName = (gateway: string) => {
  return getApiById<PaymentGatewayAdminResponse>(BASE, gateway);
};

export const savePaymentGateway = (
  gateway: string,
  payload: PaymentGatewayConfigRequest
) => {
  return putApiWithoutId<PaymentGatewayAdminResponse>(`${BASE}/${gateway}`, payload);
};

/**
 * The enable toggle.
 *
 * <p>A separate endpoint from save so switching a gateway on is never a side effect of a form submit
 * that happened to carry a half-filled credential box. The backend refuses to enable a gateway
 * without complete credentials and returns the reason.
 */
export const setPaymentGatewayEnabled = (gateway: string, isEnabled: boolean) => {
  return patchApi<PaymentGatewayAdminResponse>(`${BASE}/${gateway}`, 'enabled', { isEnabled });
};